(() => {
 'use strict';
 if(window.__TOS292_GALLERY__)return;
 const assetBase=new URL('./',document.currentScript.src).href;
 const thumbs=Object.fromEntries(['500','1000'].map(f=>[f,Object.fromEntries(['full','label','cap'].map(k=>[k,assetBase+'3os-292-thumb-'+f+'-'+k+'.webp']))]));
 const config={artDesktop:assetBase+'3os-292-club-atelier-1120.webp',artMobile:assetBase+'3os-292-club-atelier-640.webp',thumbs,...window.__TOS292_GALLERY_CONFIG__};
 const icon=path=>'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+path+'</svg>';
 const closeIcon=icon('<path d="m6 6 12 12M18 6 6 18"/>');
 const arrow=d=>icon('<path d="'+(d<0?'m14 6-6 6 6 6':'m10 6 6 6-6 6')+'"/>');
 const boot=()=>JSON.parse(document.getElementById('tos-media-290').textContent);
 let dialog=null,lastFormat=null;
 function sync(){
  const api=window.__R290_MEDIA__;if(!dialog||!api?.active)return;
  const {format,kind}=api.active;dialog.dataset.format=format;dialog.dataset.kind=kind;
  if(format===lastFormat)return;lastFormat=format;
  const data=boot();dialog.querySelectorAll('.r292-thumb').forEach(img=>{img.style.visibility='';img.src=config.thumbs?.[format]?.[img.dataset.detail]||data.paths[format][img.dataset.detail];});
 }
 function enhance(){
  const d=document.querySelector('.r290-dialog');if(!d||d.classList.contains('r292-dialog'))return;
  dialog=d;d.classList.add('r292-dialog');
  const body=d.querySelector('.r290-body'),head=d.querySelector('.r290-head'),options=d.querySelector('.r290-options'),foot=d.querySelector('.r290-foot'),view=d.querySelector('.r290-view'),close=d.querySelector('.r290-close');
  // Move existing controls; their native, tested event handlers remain intact.
  close.innerHTML=closeIcon;d.append(close);options.prepend(head);options.append(foot);
  d.querySelectorAll('.r290-mode').forEach(button=>{
   const text=button.textContent,kind=button.dataset.kind;
   const thumb=document.createElement('img');thumb.className='r292-thumb';thumb.dataset.detail=kind;thumb.alt='';thumb.setAttribute('aria-hidden','true');thumb.draggable=false;thumb.decoding='async';thumb.width=56;thumb.height=56;
   thumb.onerror=()=>{thumb.style.visibility='hidden';};thumb.onload=()=>{thumb.style.visibility='';};
   const span=document.createElement('span');span.textContent=text;button.replaceChildren(thumb,span);
  });
  d.querySelectorAll('[data-rotate]').forEach(b=>b.innerHTML=arrow(Number(b.dataset.rotate)));
  const reset=d.querySelector('[data-reset]'),resetLabel=reset.textContent;reset.setAttribute('aria-label',resetLabel);
  reset.innerHTML=icon('<path d="M5 9a8 8 0 1 1-1 7M5 3v6h6"/>');const resetText=document.createElement('span');resetText.textContent=resetLabel;reset.append(resetText);
  const rotate=d.querySelector('.r290-rotate'),zoom=d.querySelector('.r290-zoom');
  const controls=document.createElement('div');controls.className='r292-controls';options.insertBefore(controls,rotate);controls.append(rotate,zoom);
  const media=matchMedia('(max-width:699px)');
  const art=()=>{d.style.setProperty('--r292-art','url("'+(media.matches?config.artMobile:config.artDesktop)+'")');};art();media.addEventListener('change',art);
  new MutationObserver(sync).observe(view,{attributes:true,attributeFilter:['data-format','data-kind']});
  d.addEventListener('close',()=>{lastFormat=null;});
  sync();
  // Reparenting the original close button can blur it. Preserve the native
  // initial-focus contract after the visual re-composition has finished.
  if(d.open)close.focus({preventScroll:true});
 }
 new MutationObserver(enhance).observe(document.body,{childList:true});
 enhance();window.__TOS292_GALLERY__={config,enhance,sync,get dialog(){return dialog;}};
})();
